export default {
  sm: `
  Technical Expertise in 
  Consulting Services    
  `,
  lg: `
  Technical Expertise in Consulting 
  Services    
  `,
  xxl: `
  Technical Expertise in 
  Consulting Services    
  `,
};
